// eslint-disable-next-line
// @ts-ignore
import tailwindColors from 'tailwindcss/colors'

export const colors = tailwindColors
